import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userInfoAtom } from "./state";
import { UserInfo } from "./types";
import { useGetMeQuery } from "graphqlBase/currentUser/__generated__/getMe";

const scopesOnlyForStoreOwnerTenant = ["devicemodel.globalshare.tenant", "app.globalshare.tenant"];

export const useCreatUserInfo = (isAuthenticated: boolean) => {
  const setUserInfo = useSetRecoilState(userInfoAtom);
  const { data } = useGetMeQuery({ skip: !isAuthenticated });
  useEffect(() => {
    const me = data?.me;
    if (!me) return;

    const isOnStoreOwnerTenant = me.storeSetting?.isStoreOwnerTenant ?? false;

    const userInfo: UserInfo = {
      id: me.id,
      email: me.email,
      displayName: me.displayName,
      tenantId: me.tenantId,
      scopes: me.permissions.scopes.filter((scope) => {
        if (scopesOnlyForStoreOwnerTenant.includes(scope.toLowerCase())) {
          return isOnStoreOwnerTenant;
        }
        return true;
      }),
      roles: me.permissions.roles,
      isSuperAdmin: me.permissions.isSuperAdmin,
      isOnStoreOwnerTenant,
    };

    setUserInfo(userInfo);
  }, [setUserInfo, isAuthenticated, data]);
};

export const useGetUserInfo = (): UserInfo | undefined => {
  const userInfo = useRecoilValue(userInfoAtom);

  return userInfo;
};

export const useGetUserRoles = (): string[] => {
  const user = useGetUserInfo();
  if (!user) return [];
  return user.roles;
};

export const useGetUserScopes = (): string[] => {
  const user = useGetUserInfo();
  if (!user) return [];
  return user.scopes;
};
